import Vue from "vue";
import VueRouter from 'vue-router';
import VueToasted from 'vue-toasted';
import VueSelect from 'vue-select';
import VueNumerals from 'vue-numerals';
import VuePortal from 'portal-vue'
import VueTitle from './vue/packages/Title/main';
import VueAxios from './vue/packages/Axios/main';
import VueModal from 'vue-js-modal';
import VueSidebar from './vue/components/Sidebar';
import VueAlert from './vue/components/Alert';

/** Layouts */
import LayoutMaster from "./vue/layouts/master";

/** Sites */
import IndexSites from "./vue/modules/sites/index";
import ShowSites from "./vue/modules/sites/show";

/** Items */
import IndexItems from "./vue/modules/items/index";
import ShowItems from "./vue/modules/items/show";

/** Cart */
import ShowCart from "./vue/modules/cart/show";
import CartTransaction from "./vue/modules/cart/transaction";
import SlotSelect from "./vue/components/PickupSlotSelectPage";

/** Order */
import ConfirmationOrder from "./vue/modules/orders/confirmation";
import IndexOrders from './vue/modules/orders/index';
import ShowOrder from './vue/modules/orders/show';

/** Filters */
import IndexFilters from "./vue/modules/items/filters";

/** Contact */
import IndexContact from "./vue/modules/contact/index";

/** Error pages */
import ErrorPage from "./vue/modules/errors/show";

/** Auth pages */
import LoginPage from "./vue/modules/auth/login";
import ProfilePage from "./vue/modules/auth/profile";

import setupMoneyFormatFilter from '../../common/js/currency_format';


window.Vue = Vue.use(VueRouter);
window.Vue = window.Vue.use(VueToasted);
window.Vue = window.Vue.use(VueNumerals);
window.Vue = window.Vue.use(VueTitle);
window.Vue = window.Vue.use(VueAxios);
window.Vue = window.Vue.use(VuePortal);
window.Vue = window.Vue.use(VueModal);

window.Vue.component('vue-select', VueSelect);
window.Vue.component('vue-sidebar', VueSidebar);
window.Vue.component('vue-alert', VueAlert);

window.Vue.filter('ucFirst', value => {
    if (!value || value.length < 1) {
        return value;
    }

    return value.charAt(0).toUpperCase() + value.slice(1);
});

setupMoneyFormatFilter();

let redirectToLogin = function (to, from, next) {
    if (!window.app.user) {
        next('/login');
    } else {
        next();
    }
}

let redirectToMain = function (to, from, next) {
    if (window.app.user) {
        next('/');
    } else {
        next();
    }
}

export default new VueRouter({
    mode: 'history',
    routes: [
        { path: '/error/:status', component: ErrorPage },
        { path: '/:site/cart', component: ShowCart },
        { path: '/:site/cart/transaction', component: CartTransaction },
        { path: '/:site/:menu/filters', component: IndexFilters },
        { path: '/my-orders/:order', component: ShowOrder, beforeEnter: redirectToLogin },
        { path: '/my-orders', component: IndexOrders, beforeEnter: redirectToLogin },
        {
            path: '/',
            component: LayoutMaster,
            children: [
                { path: '/', component: IndexSites },
                { path: '/login', component: LoginPage, beforeEnter: redirectToMain },
                { path: '/profile', component: ProfilePage, beforeEnter: redirectToLogin },
                { path: ':site', component: ShowSites },
                { path: ':site/select-slot', component: SlotSelect },
                { path: ':site/contact', component: IndexContact },
                { path: ':site/:menu', component: IndexItems },
                { path: '/:site/orders/:identifier/payment-confirmation', component: ConfirmationOrder, name: 'payment-confirmation' },
            ]
        },
        { path: '/:site/:menu/:section/:item', component: ShowItems },
        {
            path: '*',
            beforeEnter: (to, from, next) => { next('/') }
        }
    ]
});

